import { FlashMessage } from '@pegasus/ui-flashmessages';
import { HeaderFlashMessage } from '@shared/types/flashMessage';

export interface State {
    flashMessages: FlashMessage[];
    displayHeaderFlashMessage: boolean;
    headerFlashMessage: HeaderFlashMessage;
    errors: Error[];
    // eslint-disable-next-line no-undef
    headerNotificationBanner: JSX.Element;
    showNotification: boolean;
}

export const initialState: State = {
    flashMessages: [],
    displayHeaderFlashMessage: false,
    headerFlashMessage: null,
    errors: [],
    headerNotificationBanner: null,
    showNotification: false,
};
